import * as Yup from "yup";
import { Intervention } from "../../generated/graphql";
import { getInitialValues } from "../../services/config";
import { nextISOWeek } from "../../services/utils";
import isWeekValidForPermit from "./isWeekValidForPermit";

const getSchema = () => {
    const { year, week } = nextISOWeek()

    return Yup.object().shape({
        workPermit: Yup.mixed().required().default(null),
        year: Yup.number().integer().required().default(year),
        week: Yup.number().integer().required().default(week).test(
            "contractBounded", "Fora das datas da permissão de trabalho",
            function() {
                const { week, year, workPermit } = this.parent
                if (!workPermit) return true
                return isWeekValidForPermit(workPermit.startAt, workPermit.endAt, year, week)
            })
    })
}

const interventionFormInit = (intervention: Intervention) => {
    const schema = getSchema()
    const initial = intervention ? intervention : getInitialValues(schema)
    return { schema, initial }
}


export default interventionFormInit
